import React, { ReactNode } from 'react';
import classNames from 'classnames';

import { Button } from '../../atoms/button';
import Text from '../../atoms/text/Text';

export interface SummaryCardType {
  prefixIcon?: ReactNode;
  label?: string;
  value?: number;
  body?: ReactNode;
  styles?: {
    border?: string;
    color?: string;
    background?: string;
  };
  button?: {
    label?: string;
    color?: string;
    background?: string;
    onClick?: () => void;
  };
}

const SummaryCard = ({
  prefixIcon,
  label,
  value,
  styles,
  button,
  body,
}: SummaryCardType) => {
  return (
    <div
      className={classNames('p-12 rounded-6 border', {
        [styles?.background]: styles?.background,
        [styles?.border]: styles?.border,
      })}
    >
      <div className="d-flex align-items-center gap-10">
        {prefixIcon && prefixIcon}
        <Text size="sm" weight="medium" color="subtitle1">
          {label}
        </Text>
      </div>
      <div className="mt-12 d-flex justify-content-between align-items-center gap-2">
        <Text
          size="md"
          weight="semibold"
          sizeType="display"
          className={classNames({
            [styles?.color]: styles?.color,
          })}
        >
          {value && value?.toLocaleString()}
          {body && body}
        </Text>
        {button && (
          <Button
            size="sm"
            onClick={button.onClick}
            className={classNames({
              [button?.color]: button?.color,
              [button?.background]: button?.background,
            })}
          >
            {button?.label}
          </Button>
        )}
      </div>
    </div>
  );
};

export default SummaryCard;
